import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { ProcessStatus } from "../../../process/Process.types.ts";
import { getProcessStatusOptions } from "../../../process/processStatus.ts";

export interface ProcessStatusFieldProps {
    status?: ProcessStatus;
    onChange: (status: ProcessStatus) => void;
    disabled: boolean;
    errorText?: string;
}

function ProcessStatusField(props: ProcessStatusFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getProcessStatusOptions(translateString)}
            selectedItem={props.status ? props.status.toString() : null}
            onChange={(status) => props.onChange(Number(status) as ProcessStatus)}
            placeholder={translateString("status")}
            label={translateString("status")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
            disableClearable
        />
    );
}

export default ProcessStatusField;
